<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="680px">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.materialCustomerId" class="title-actions">
        <el-button v-if="isAuth('base:materialCustomer:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:materialCustomer:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="110px" @keyup.enter.native="readonly ? undefined : save()">
      <el-form-item label="主物料" prop="materialId">
        <el-select v-model="form.materialId" :disabled="readonly" style="width:100%" filterable>
          <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户" prop="customerId">
        <el-input v-model="form.customerName" readonly placeholder="请选择客户">
          <el-button v-if="!readonly" slot="append" @click="customerVisible = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="客户物料编码" prop="cusMaterialCode">
        <el-input v-model="form.cusMaterialCode" :disabled="readonly" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="3" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>
    <customer-selector :visible.sync="customerVisible" @select="onCustomer" />
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import CustomerSelector from '../../components/CustomerSelector.vue'

export default {
  components: { CustomerSelector },
  data() {
    return {
      visible: false, readonly: false, form: {}, materials: [], permCodes: [], customerVisible: false,
      rules: {
        materialId: [{ required: true, message: '主物料不能为空', trigger: 'change' }],
        customerId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        cusMaterialCode: [{ required: true, message: '客户物料编码不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看物料客户'
      return this.form.materialCustomerId ? '修改物料客户' : '新增物料客户'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(row, readonly, materialId) {
      this.loadMaterials()
      this.readonly = !!readonly
      this.visible = true
      const blank = () => ({
        materialId: materialId || '', customerId: '', customerName: '',
        cusMaterialCode: '', remark: ''
      })
      const apply = data => {
        this.form = Object.assign(blank(), data || {})
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }
      if (!row || !row.materialCustomerId) {
        apply(blank())
        return
      }
      request.get('/base/materialCustomer/info/' + row.materialCustomerId).then(res => apply(res.data || row)).catch(() => apply(row))
    },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    onCustomer(row) {
      this.form.customerId = row.customerId
      this.form.customerName = row.customerName
      this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.validateField('customerId') })
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/base/materialCustomer/' + (this.form.materialCustomerId ? 'update' : 'save'), this.form).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/materialCustomer/delete', { materialCustomerId: this.form.materialCustomerId }).then(() => {
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>
